<template>
  <!--管理服务人员账号-->
  <el-dialog title="编辑账号" :visible.sync="showManage" width="30%" @close="$emit('update:show',false)">
    <el-form ref="ruleForm" :model="account" class="dialog-form" :rules="rules">
      <el-form-item label="账号" :label-width="formLabelWidth">
        {{ account.account }}
      </el-form-item>

      <el-form-item label="所属门店" :label-width="formLabelWidth">
        {{ account.store ? account.store.store_name : '' }}
      </el-form-item>

      <el-form-item label="使用者昵称" :label-width="formLabelWidth">
        <el-input v-model="account.real_name" type="text" autocomplete="off" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateStoreAccount as updateAccount } from '@/api/storeAccount'
export default {

  props: {
    accountInfo: {
      type: Object,
      default() {
        return null
      }
    },

    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var validatePass = (rule, value, callback) => {
      const reg = /^[0-9A-Za-z]{6,12}$/
      if (!reg.test(value)) {
        callback(new Error('密码至少6位数字或字母'))
      } else {
        if (this.account.checkPsw !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.account.psw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      showManage: this.show, // 打开密码修改
      account: { // 当前选中账号信息

      },
      info: this.accountInfo,
      formLabelWidth: '100',
      rules: {
        psw: [{ validator: validatePass, trigger: 'blur' }],
        checkPsw: [{ validator: validatePass2, trigger: 'blur' }]
      },
      loading: false
    }
  },

  watch: {
    show(n) {
      this.showManage = this.show
    },
    accountInfo() {
      this.account = this.accountInfo
      // this.account.user = this.accountInfo.operate_user.username
      console.log(this.account)
    }
  },

  methods: {
    onSubmit(name) {
      this.$refs[name].validate(valid => {
        this.loading = true
        updateAccount(this.account.id, {
          real_name: this.account.real_name
        }).then(response => {
          // 关闭弹层
          this.$emit('update:show', false)
          // 更新数据
          this.$emit('updateInfo', response.data)
          this.$message({
            message: '更新账号信息成功',
            type: 'success',
            duration: 3 * 1000
          })
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/dialog-form.scss';
</style>
